// 定义一个全局混入对象
import Vue from "vue";
Vue.mixin({
  data: () => {
    return {};
  },
  filters: {
    image(value, width, height) {
      if (!value) return "";
      if (value.indexOf("//") >= 0) return value;
      if (width) return `//img13.360buyimg.com/n5/s${width}x${height}_${value}`;
      return `//img13.360buyimg.com${value}`;
    },
    moneyUnit(value) {
      if (!value) return "";
      if (value < 10000) return Number(value / 1).toFixed(0);
      if (value >= 10000) return Number(value / 10000).toFixed(1) + "万";
    },
    priceSplit(value, num) {
      if (!value) {
        return "--"
      } else {
        return value.split('.')[num]
      }
    },
    timeFormat(value) {
      if (!value) return "";
      return new Date(value).Format("yyyy.MM.dd");
    }
  },
  methods: {
    //获取url中参数
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    //判断对象类型
    isType(arg) {
      return Object.prototype.toString.call(arg);
    },
    getDateFormat(row, column, cellValue) {
      return new Date(cellValue).toLocaleString("zh-CN", {
        hour12: false
      });
    },
    bury(event, json) {
      try {
        var eventId = event; // 必选参数，事件id
        var click = new window.MPing.inputs.Click(eventId); // 构造点击上报对象
        // click.event_param = event // 设置click事件参数
        click.json_param = json; // 设置json格式事件参数，必须是合法的json字符串
        click.updateEventSeries(); // 更新事件串
        new window.MPing().send(click); // 构造上报实例，上报点击事件
      } catch (e) {
        console.log(e);
      }
    }
  }
});
